import request from '@/config/axios'

// 入住人管理 VO
export interface OrderGuestVO {
  id?: string | number
  orderId: string | number
  roomId?: string | number
  name: string
  idType?: string // ID_CARD/PASSPORT/OTHER
  idNumber?: string
  phone?: string
  gender?: number // 0=未知 1=男 2=女
  isPrimary?: number // 0=同行人 1=主客
  checkInTime?: string
  checkOutTime?: string
  createTime?: Date
}

// 获取入住人分页
export const getOrderGuestPage = (params: any) => {
  return request.get({ url: '/hotel/order-guest/page', params })
}

// 获取入住人详情
export const getOrderGuest = (id: string | number) => {
  return request.get({ url: '/hotel/order-guest/get?id=' + id })
}

// 创建入住人
export const createOrderGuest = (data: OrderGuestVO) => {
  return request.post({ url: '/hotel/order-guest/create', data })
}

// 更新入住人
export const updateOrderGuest = (data: OrderGuestVO) => {
  return request.put({ url: '/hotel/order-guest/update', data })
}

// 删除入住人
export const deleteOrderGuest = (id: string | number) => {
  return request.delete({ url: '/hotel/order-guest/delete?id=' + id })
}

// 批量删除入住人
export const deleteOrderGuestList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/order-guest/delete-list?ids=' + ids.join(',') })
}
